export const translations = {
  en: {
    appTitle: 'Tic Tac Toe-Pro',
    arenaTitle: 'Neon AI Arena',
    menuTitle: 'TIC TAC TOE',
    menuSubtitle: 'Choose a mode and difficulty',
    startGame: 'Start Game',
    playerNames: 'Player names',
    expertHint: 'Expert uses full-depth minimax with alpha-beta pruning and perfect tie-breaking.',
    restart: 'Restart',
    back: 'Back',
    menu: 'Menu',
    save: 'Save',
    playAgain: 'Play again',
    scoreboard: 'Scoreboard',
    draw: 'Draw',
    drawRate: 'draw rate',
    winRate: 'win rate',
    currentTurn: 'Current turn',
    gameMode: 'Game mode',
    difficulty: 'Difficulty',
    resetRound: 'Reset round',
    resetScores: 'Reset scores',
    soundOn: 'Sound on',
    muted: 'Muted',
    languageName: 'Arabic',
    muteSound: 'Mute sound',
    enableSound: 'Enable sound',
    toggleLanguage: 'Toggle language',
    playerNamesTitle: 'Player Names',
    playerNamesHelp: 'Arabic and English names are supported.',
    firstPlayer: 'First player (X)',
    secondPlayer: 'Second player (O)',
    noWinner: 'No winner this round',
    perfectLine: 'Perfect line secured',
    wins: 'wins',
    aiStats: 'AI stats',
    state: 'State',
    thinking: 'thinking...',
    ready: 'ready',
    nodesExplored: 'Nodes explored',
    prunedBranches: 'Pruned branches',
    thinkingTime: 'Thinking time',
    bestMoveIndex: 'Best move index',
    evaluatedOrder: 'Evaluated order',
    aiThinking: 'AI thinking',
    cell: 'Cell',
    occupiedBy: 'occupied by',
    turn: 'turn',
    isThinking: 'is thinking',
    versus: 'vs',
    milliseconds: 'ms',
    modeNames: {
      human_ai: 'Human vs AI',
      human_human: 'Human vs Human',
      ai_ai: 'AI vs AI Demo',
      minimax_random: 'Minimax AI vs Random AI',
    },
    modeDescriptions: {
      human_ai: 'Classic challenge',
      human_human: 'Two players',
      ai_ai: 'Watch minimax think',
      minimax_random: 'Strategy lab',
    },
    difficulties: {
      Easy: 'Easy',
      Medium: 'Medium',
      Hard: 'Hard',
      Expert: 'Expert',
    },
    defaultNames: {
      human: 'Human',
      ai: 'AI',
      minimaxAi: 'Minimax AI',
      randomAi: 'Random AI',
      aiX: 'AI X',
      aiO: 'AI O',
      player1: 'Player 1',
      player2: 'Player 2',
    },
  },
  ar: {
    appTitle: 'إكس أو - برو',
    arenaTitle: 'ساحة النيون للذكاء الاصطناعي',
    menuTitle: 'إكس أو',
    menuSubtitle: 'اختر وضع اللعب ومستوى الذكاء الاصطناعي',
    startGame: 'ابدأ اللعبة',
    playerNames: 'أسماء اللاعبين',
    expertHint: 'مستوى الخبير يستخدم Minimax بعمق كامل مع تقليم ألفا-بيتا واختيار مثالي.',
    restart: 'إعادة الجولة',
    back: 'رجوع',
    menu: 'القائمة',
    save: 'حفظ',
    playAgain: 'العب مرة أخرى',
    scoreboard: 'لوحة النتائج',
    draw: 'تعادل',
    drawRate: 'نسبة التعادل',
    winRate: 'نسبة الفوز',
    currentTurn: 'الدور الحالي',
    gameMode: 'وضع اللعب',
    difficulty: 'المستوى',
    resetRound: 'إعادة الجولة',
    resetScores: 'تصفير النتائج',
    soundOn: 'الصوت يعمل',
    muted: 'الصوت مغلق',
    languageName: 'English',
    muteSound: 'كتم الصوت',
    enableSound: 'تشغيل الصوت',
    toggleLanguage: 'تبديل اللغة',
    playerNamesTitle: 'أسماء اللاعبين',
    playerNamesHelp: 'يمكن استخدام أسماء عربية أو إنجليزية.',
    firstPlayer: 'اللاعب الأول (X)',
    secondPlayer: 'اللاعب الثاني (O)',
    noWinner: 'لا يوجد فائز في هذه الجولة',
    perfectLine: 'تم تكوين خط الفوز',
    wins: 'فاز',
    aiStats: 'إحصائيات الذكاء الاصطناعي',
    state: 'الحالة',
    thinking: 'يفكر...',
    ready: 'جاهز',
    nodesExplored: 'العقد المفحوصة',
    prunedBranches: 'الفروع المستبعدة',
    thinkingTime: 'وقت التفكير',
    bestMoveIndex: 'رقم أفضل خانة',
    evaluatedOrder: 'ترتيب التقييم',
    aiThinking: 'الذكاء الاصطناعي يفكر',
    cell: 'الخانة',
    occupiedBy: 'مشغولة بـ',
    turn: 'الدور',
    isThinking: 'يفكر',
    versus: 'ضد',
    milliseconds: 'مللي ثانية',
    modeNames: {
      human_ai: 'لاعب ضد الذكاء الاصطناعي',
      human_human: 'لاعب ضد لاعب',
      ai_ai: 'عرض ذكاء اصطناعي ضد ذكاء اصطناعي',
      minimax_random: 'Minimax ضد ذكاء اصطناعي عشوائي',
    },
    modeDescriptions: {
      human_ai: 'تحدي كلاسيكي',
      human_human: 'لاعبان على نفس الجهاز',
      ai_ai: 'شاهد Minimax وهو يفكر',
      minimax_random: 'مختبر الاستراتيجية',
    },
    difficulties: {
      Easy: 'سهل',
      Medium: 'متوسط',
      Hard: 'صعب',
      Expert: 'خبير',
    },
    defaultNames: {
      human: 'لاعب',
      ai: 'الذكاء الاصطناعي',
      minimaxAi: 'ذكاء Minimax الاصطناعي',
      randomAi: 'ذكاء اصطناعي عشوائي',
      aiX: 'ذكاء اصطناعي X',
      aiO: 'ذكاء اصطناعي O',
      player1: 'اللاعب 1',
      player2: 'اللاعب 2',
    },
  },
};

export function getTranslations(language) {
  return translations[language] ?? translations.en;
}

export function translateDifficulty(difficulty, language) {
  return getTranslations(language).difficulties[difficulty] ?? difficulty;
}

export function translateMode(mode, language) {
  return getTranslations(language).modeNames[mode] ?? mode;
}
